import React from "react";
import "./home.scss";
import Dashboard from "../../layout/Dashboard/Dashboard";
import CookieManager from "../../components/Cookies/CookieManager";
import { useTranslation } from "react-i18next";
import "../../i18n";
import { Link } from "react-router-dom";

const Home = () => {
  const { t } = useTranslation();

  return (
    <div>
      <CookieManager />
      <Dashboard>
        <div className="row">
          <p className="description mb-5">{t("homePage.description")}</p>
        </div>

        <div className="row mb-5">
          <h3>{t("homePage.pivotTitle")}</h3>
          <p>
            {t("homePage.pivotDescription")}{" "}
            <Link to="/create-chart" className="black-link">
              {t("homePage.createChart")}
            </Link>{" "}
            {t("homePage.pivotDescription2")}
            <ul>
              <li>
                <strong>{t("homePage.pivotRowsCols")}:</strong>{" "}
                {t("homePage.pivotRowsColsDesc")}
              </li>
              <li>
                <strong>{t("homePage.pivotAggregators")}:</strong>{" "}
                {t("homePage.pivotAggregatorsDes")}
              </li>
              <li>
                <strong>{t("homePage.pivotValues")}:</strong>{" "}
                {t("homePage.pivotValuesDes")}
              </li>
              <li>
                <strong>{t("homePage.pivotFilters")}:</strong>{" "}
                {t("homePage.pivotFilterDes")}
              </li>
            </ul>
          </p>
          <img
            src="/doc-img-1.png"
            alt="Pivot Table Variables"
            className="img-fluid"
            style={{ maxWidth: "80%", height: "auto" }}
          />
        </div>

        <div className="aggregators-info">
          <h3>{t("homePage.valuesTitle")}</h3>
          <p>
            <strong>{t("homePage.valuesDesc")}:</strong>{" "}
            {t("homePage.valueDes2")}
          </p>
          <p>
            <strong>{t("homePage.aggDesc")}:</strong> {t("homePage.aggDesc2")}
            <ul>
              <li>
                <strong>{t("homePage.aggSum")}:</strong>{" "}
                {t("homePage.aggSumDesc")}
              </li>
              <li>
                <strong>{t("homePage.aggAvg")}:</strong>{" "}
                {t("homePage.aggAvgDes")}
              </li>
              <li>
                <strong>{t("homePage.aggCount")}:</strong>{" "}
                {t("homePage.aggCountDes")}
              </li>
              <li>
                <strong>{t("homePage.aggMin")}:</strong>{" "}
                {t("homePage.aggMinDes")}
              </li>
              <li>
                <strong>{t("homePage.aggMax")}:</strong>{" "}
                {t("homePage.aggMaxDes")}
              </li>
              <li>
                <strong>{t("homePage.aggMedian")}:</strong>{" "}
                {t("homePage.aggMedianDes")}
              </li>
            </ul>
          </p>
          <p>
            <strong>{t("homePage.valuesAggLink").split(":")[0]}:</strong>{" "}
            {t("homePage.valuesAggLink").split(":")[1]}
          </p>
          <p>
            <strong>{t("homePage.aggInViz").split(":")[0]}:</strong>{" "}
            {t("homePage.aggInViz").split(":")[1]}
          </p>
          <img
            src="/doc-img-2.png"
            alt="Pivot Table Variables"
            className="img-fluid"
            style={{ maxWidth: "80%", height: "auto" }}
          />
        </div>

        <div className="row mb-5">
          <h3>{t("homePage.chartTypesTitle")}</h3>
          <ul>
            <li>{t("homePage.chartGroupedCol")}</li>
            <li>{t("homePage.chartStackedCol")}</li>
            <li>{t("homePage.chartGroupedBar")}</li>
            <li>{t("homePage.chartStackedBar")}</li>
            <li>{t("homePage.chartLine")}</li>
            <li>{t("homePage.chartDot")}</li>
            <li>{t("homePage.chartArea")}</li>
            <li>{t("homePage.chartScatter")}</li>
            <li>{t("homePage.chartMultiPie")}</li>
          </ul>
        </div>

        <div className="row mb-5">
          <h3>{t("homePage.chartChoiceTitle")}</h3>
          <ul>
            <li>{t("homePage.chartChoiceCompare")}</li>
            <li>{t("homePage.chartChoiceTrends")}</li>
            <li>{t("homePage.chartChoiceWhole")}</li>
            <li>{t("homePage.chartChoiceDist")}</li>
            <li>{t("homePage.chartChoiceGeo")}</li>
          </ul>
        </div>
      </Dashboard>
    </div>
  );
};

export default Home;
